








































































































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';
import { PromotionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/promotion-type.enum';

import {
  CrudForm,
  KeywordsInput,
  RegularFilterSelector,
  Slider,
  UiCheckbox,
  UiIconButton,
  UiModal,
  UiRadioGroup,
  UiTextbox
} from '../../components';

import { CrudFormMixin } from '../../mixins/crud-form.mixin';

import { Dictionary, RegularFilter } from '../../models';

import { ROUTER_CONSTS } from '../../router/router.consts';

export default {
  name: 'promotions-form',
  mixins: [CrudFormMixin],
  components: {
    CrudForm,
    KeywordsInput,
    RegularFilterSelector,
    Slider,
    UiCheckbox,
    UiIconButton,
    UiModal,
    UiTextbox,
    UiRadioGroup
  },
  computed: {
    keywordsHelp: function () {
      return this.item.matchAll ? this.messages.fields.placeholders.keywords.disabled : this.messages.fields.placeholders.keywords.active;
    },
    typeRadioGroupOptions: function (): any[] {
      return Object.values(PromotionTypeEnum).map((type: string) => ({
        value: type,
        label: this.messages.fields.type.values[type]
      }));
    },
    typeSelectedValue: function (): PromotionTypeEnum {
      const selectedOption = this.typeRadioGroupOptions.find((option: any) => (option.value === this.item.type));
      return (!!selectedOption ? selectedOption.value : '');
    },
    filters: function (): Dictionary<RegularFilter> {
      const filters = CrudFormMixin.computed.filters.bind(this)();
      filters.lang.config.mandatory = true;
      return filters;
    },
    valid: function (): boolean {
      if (!this.item.type) {
        return false;
      }
      if (!this.item.filters.lang.length) {
        return false;
      }
      if (!this.item.matchAll && !this.item.keywords.length) {
        return false;
      }
      if (!this.item.url) {
        return false;
      }
      if (!this.item.imageUrl) {
        return false;
      }
      return true;
    }
  },
  data: function () {
    return {
      dataType: ActionTypeEnum.PROMOTION,
      updateMode: (this.$route.name === ROUTER_CONSTS.routes.promotions.update),
      item: {
        enabled: true,
        type: Object.values(PromotionTypeEnum)[0],
        keywords: [],
        title: '',
        weight: 0,
        filters: {
          lang: []
        },
        schedule: {
          activationDate: null,
          deactivationDate: null
        }
      },
      messages: this.$epb.messages.tools.promotions,
      PromotionTypeEnum
    };
  },
  methods: {
    onTypeValueChange: function (type: PromotionTypeEnum) {
      this.item.type = type;
    },
    onWeightSelectorChange: function (newValue: number) {
      this.item.weight = newValue;
    },
    onImageError: function (event) {
      event.target.src = require('../../assets/media/image/image-not-found.svg');
      this.$refs.imageUrlPreviewModalImage.src = require('../../assets/media/image/image-not-found.svg');
    }
  },
  watch: {
    'item.matchAll': function (matchAll: boolean): void {
      if (matchAll) {
        this.item.keywords = [];
      }
    }
  }
};

